import { Component, OnInit } from '@angular/core';
import { DashCodeHelper } from '@app/_shared/_helpers/dashcode.helper';

@Component({
  selector: 'dashlayout-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  constructor(public dashcodeHelper:DashCodeHelper) { }

  ngOnInit(): void {
  }

}
